export function mapDataToObject(obj, data) {
    for(let k of Object.keys(data)) {
        if (obj[k] == undefined) {
            continue
        }
        if (typeof obj[k] == "object" && typeof data[k] == "object") {
            mapDataToObject(obj[k], data[k])
        }
        else if(typeof obj[k] == typeof data[k]) {
            obj[k] = data[k]
        }
    }
}

export function setValueNestedObj(path, value, obj) {
    let keys = Array.isArray(path) ? path : path.split(".")
    if (keys.length > 1) {
        if (!obj.hasOwnProperty(keys[0]) || typeof obj[keys[0]] !== "object") obj[keys[0]] = {}
        return setValueNestedObj(keys.slice(1), value, obj[keys[0]])
    } else {
        obj[keys[0]] = value
        return true
    }    
}